import React from "react";

const render = (unit, record) => {
    if (unit) {
        if (record.is_word) {
            return <>{record.effective_word_count} WC</>;
        } else {
            return (
                <>
                    {record.base_unit_amount} {unit?.name}
                </>
            );
        }
    }
};

export default render;
